const popup = document.getElementById('freeShippingPopup')
const closePopup = document.getElementById('closePopup')
const form = document.getElementById('freeShippingForm')

// Show popup after 5 seconds with fade-in animation
setTimeout(() => {
  popup.classList.remove('hidden') // Trigger fade-in
}, 5000)

// Close popup immediately without fade-out
closePopup.addEventListener('click', () => {
  popup.classList.add('hidden') // Instantly hide the pop-up
})

// Form submission handler
form.addEventListener('submit', (e) => {
  e.preventDefault()
  const email = document.getElementById('email').value

  // Simulate sending email to a server
  console.log(`Email submitted: ${email}`)

  // Show success message (optional)
  alert('Thank you for signing up! Free shipping is now activated.')

  // Hide the popup
  popup.classList.add('hidden')
})
